import { unstable_debounce as debounce } from '@material-ui/utils';
export default debounce;